import {Box, useTheme} from "@mui/material";
import FormSection from "../../../forms/FormSection";
import { observer } from "mobx-react";
import LayoutContentWrapper from "../../../components/layout/LayoutContentWrapper";
import * as React from "react";
import Typography from "@mui/material/Typography";
import MoneyRenderer from "../../../utils/MoneyRenderer";
import {styles} from "../../app_layout/AppLayoutStyles";
import FilledButton from "../../../components/buttons/FilledButton";
import ReceiptIcon from '@mui/icons-material/Receipt';

function AdvancePaymentRequestComponent({order, paymentProof, orderPrices}) {
    const theme = useTheme();
    const style = styles(theme);
    return (
        <LayoutContentWrapper
            renderContent={() => (
                <div>
                    <Box mb={2}>
                        <div style={{...style.titleContainer, display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <Typography
                                component="a"
                                href={`/order/${order.number}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                variant={"h2"}
                                sx={{ color: theme.palette.primary.main, fontSize: '1.5em' }}
                            >
                                Pedido {order.number}
                            </Typography>
                            <FilledButton
                                onClick={() => window.open(paymentProof.file.url, "_blank", "noopener,noreferrer")}
                            >
                                <ReceiptIcon fontSize="medium" />
                                Comprobante de pago
                            </FilledButton>
                        </div>
                    </Box>
                    <FormSection title="Pago Anticipado">
                        <div className="totales-container">
                            <table className="table-totales" style={style.totalesTable}>
                                <tbody>
                                <tr>
                                    <td style={style.totalesCell}>SUBTOTAL</td>
                                    <td className="text-right" style={{...style.totalesValueCell, ...style.totalesRegularRowCell}}>{MoneyRenderer(orderPrices.articlesTotalPrice)}</td>
                                </tr>
                                <tr>
                                    <td style={{...style.totalesCell, ...style.totalesRegularRowCell}}>IVA</td>
                                    <td className="text-right" style={{...style.totalesValueCell, ...style.totalesRegularRowCell}}>{MoneyRenderer(orderPrices.totalVAT)}</td>
                                </tr>
                                <tr>
                                    <td style={{...style.totalesCell, ...style.totalesRegularRowCell}}>IIBB</td>
                                    <td className="text-right" style={{...style.totalesValueCell, ...style.totalesRegularRowCell}}>{MoneyRenderer(orderPrices.totalGrossIncomeTaxes)}</td>
                                </tr>
                                <tr className="total-row">
                                    <td style={style.totalesRowCell}>TOTAL</td>
                                    <td className="text-right" style={style.totalesRowValueCell}>{MoneyRenderer(orderPrices.total)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </FormSection>
                </div>
            )}
        />
    );
}

export default observer(AdvancePaymentRequestComponent);